import { render, staticRenderFns } from "./bankrupt-due-right.vue?vue&type=template&id=6ad91eb6&scoped=true&"
import script from "./bankrupt-due-right.vue?vue&type=script&lang=js&"
export * from "./bankrupt-due-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad91eb6",
  null
  
)

export default component.exports